import React from 'react';
import WeatherLittleFormPage from 'pages/Configuration/ConfigurationViews/ConfigurationWidget/WidgetsForms/Weather/WeatherLittle';
import * as Yup from 'yup';
import WidgetForm from '../WidgetForm';
import useFirebase from 'hooks/Firebase/useFirebase';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const WLForm = {
    city: {
        name: "city",
        placeholder: "City",
        label: "City",
        required: true,
    },
    degrees: {
        name: "degrees",
        placeholder: "Metrics or Imperial",
        label: "Metrics or Imperial"
    },
    timer: {
        name: "timer",
        placeholder: "Timer (ms)",
        label: "Refresh timer",
        required: true
    }
}


const WLValidate = Yup.object().shape({
    [WLForm.city.name]: Yup.string().required("Required"),
    [WLForm.degrees.name]: Yup.string().oneOf(["metrics", "imperial"], "It only can be 'metrics' or 'imperial'").notRequired(),
    [WLForm.timer.name]: Yup.number().required("Required")
})

const WeatherLittleForm = (props) => {
    const [, addElement] = useFirebase()
    const [WLInitial, setWLInitial] = React.useState({
        [WLForm.city.name]: "",
        [WLForm.degrees.name]: "metrics",
        [WLForm.timer.name]: ""
    })
    const {widgets} = useSelector(state => state.widgets);

    React.useEffect(() => {
        if (props.widget) {
            setWLInitial(props.widget);
        }
    }, [props.widget])

    const handleSubmit = (values, formikBag) => {
        if (props.handleEdit) {
            props.handleEdit(values);
            const valuesParsed = widgets?.map(el => {
                if (el.id === props.widgetID) {
                    return {
                        ...el.widget,
                        ...values,
                    };
                }
                return el.widget;
            })
            addElement.setWidget("users", valuesParsed)
            toast("The widget was updated !");
            return
        }
        addElement.widget("users", {
            service_id: props.serviceSelected.id,
            widget_id: props.widgetSelected.id,
            timer: values[WLForm.timer.name],
            degrees: values[WLForm.degrees.name],
            city: values[WLForm.city.name]
        });

        formikBag.resetForm()
        toast("The widget was added to your dashboard !");
    }

    return (
        <WidgetForm WForm={WLForm} WInitial={WLInitial} WValidate={WLValidate} handleSubmit={handleSubmit}>
            <WeatherLittleFormPage handleEdit={props.handleEdit} />
        </WidgetForm>
    );
};

export default WeatherLittleForm;